Object.defineProperty(exports, "__esModule", { value: true });
var assign = require("lodash/assign");
function SimpleQueryString(query, options) {
    if (options === void 0) { options = {}; }
    if (!query) {
        return;
    }
    return {
        "simple_query_string": assign({ query: query }, options)
    };
}
exports.SimpleQueryString = SimpleQueryString;
//# sourceMappingURL=SimpleQueryString.js.map


//////////////////
// WEBPACK FOOTER
// ./~/searchkit/lib/core/query/query_dsl/full_text/SimpleQueryString.js
// module id = 876
// module chunks = 124